import { type ExprNode, type FuncName } from './node';
import { CONSTANTS } from './parse';

export function evaluate(node: ExprNode, scope: Record<string, number> = {}): number {
  switch (node.kind) {
    case 'num': {
      return node.value;
    }
    case 'var': {
      if (node.name in CONSTANTS) {
        return CONSTANTS[node.name]!;
      }
      const value = scope[node.name];
      return value !== undefined ? value : NaN;
    }
    case 'add': {
      let sum = 0;
      for (const child of node.children) {
        sum += evaluate(child, scope);
      }
      return sum;
    }
    case 'mul': {
      let product = 1;
      for (const child of node.children) {
        product *= evaluate(child, scope);
      }
      return product;
    }
    case 'pow': {
      const base = evaluate(node.base, scope);
      const exp = evaluate(node.exp, scope);
      return Math.pow(base, exp);
    }
    case 'func': {
      return evaluateFunc(node.name, node.args, scope);
    }
  }
}

function evaluateFunc(name: FuncName, args: ExprNode[], scope: Record<string, number>): number {
  switch (name) {
    case 'sin':
      return Math.sin(evaluate(args[0]!, scope));
    case 'cos':
      return Math.cos(evaluate(args[0]!, scope));
    case 'tan':
      return Math.tan(evaluate(args[0]!, scope));
    case 'asin':
      return Math.asin(evaluate(args[0]!, scope));
    case 'acos':
      return Math.acos(evaluate(args[0]!, scope));
    case 'atan':
      return Math.atan(evaluate(args[0]!, scope));
    case 'sinh':
      return Math.sinh(evaluate(args[0]!, scope));
    case 'cosh':
      return Math.cosh(evaluate(args[0]!, scope));
    case 'tanh':
      return Math.tanh(evaluate(args[0]!, scope));
    case 'sqrt':
      return Math.sqrt(evaluate(args[0]!, scope));
    case 'cbrt':
      return Math.cbrt(evaluate(args[0]!, scope));
    case 'exp':
      return Math.exp(evaluate(args[0]!, scope));
    case 'log':
      return Math.log(evaluate(args[0]!, scope));
    case 'ln':
      return Math.log(evaluate(args[0]!, scope));
    case 'log2':
      return Math.log2(evaluate(args[0]!, scope));
    case 'log10':
      return Math.log10(evaluate(args[0]!, scope));
    case 'abs':
      return Math.abs(evaluate(args[0]!, scope));
    case 'sign':
      return Math.sign(evaluate(args[0]!, scope));
    case 'floor':
      return Math.floor(evaluate(args[0]!, scope));
    case 'ceil':
      return Math.ceil(evaluate(args[0]!, scope));
    case 'round':
      return Math.round(evaluate(args[0]!, scope));
    case 'min':
      return Math.min(...args.map((arg) => evaluate(arg, scope)));
    case 'max':
      return Math.max(...args.map((arg) => evaluate(arg, scope)));
    case 'pow':
      return Math.pow(evaluate(args[0]!, scope), evaluate(args[1]!, scope));
  }
}
